import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, GetTaxListBO, saveRelationshipListBO } from '../taxs-details.modal';
import { RLService } from './relationship-list.service';
import { RelationshipListDateService } from './relationship-listdateservice';

@Component({
  selector: 'app-relationship-list',
  templateUrl: './relationship-list.component.html',
  styleUrls: ['./relationship-list.component.scss']
})
export class RelationshipListComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridRL') public gridRL: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  saveRLInfo: saveRelationshipListBO = new saveRelationshipListBO();
  RLFilterBo: GetTaxListBO = new GetTaxListBO();
  isSaveorUpdateBoolean:boolean=false;
  constructor(public DateService: RelationshipListDateService,
    public service: RLService,
    public global: GlobalComponent, public toasterservice: ToastrService) {

    this.GridList = DateService;
  }
  fp: functionpermission = new functionpermission()

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getRelationListFilter();
  }


  // ................................................dataChangeRL..............................................
  public dataChangeRL(RL): void {
    let val = (RL.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((RL.sorted || []).length) {
        this.RLFilterBo.orderColumn = RL.sorted[0].name;
        this.RLFilterBo.orderType = RL.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && RL.action.action != "clearFilter") {
      this.RLFilterBo.value = RL.action.currentFilterObject.value;
      this.RLFilterBo.field = RL.action.currentFilterObject.field;
      this.RLFilterBo.matchCase = RL.action.currentFilterObject.matchCase;
      this.RLFilterBo.operator = RL.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && RL.action.action == "clearFilter") {
        this.RLFilterBo.field = "relationship_Name";
        this.RLFilterBo.matchCase = false;
        this.RLFilterBo.operator = "contains";
        this.RLFilterBo.value = "";
        this.RLFilterBo.type = "string";
      }
    }
    this.getRelationListFilter();
    if (val == "paging" && RL.action.name == "actionBegin") {

    }
  }
  //.........................................onActionRL.....................................................
  public onActionRL(RL) {
    this.RLFilterBo.currentpageno = this.gridRL.pagerModule.pagerObj.currentPage;
    this.RLFilterBo.pageitem = this.gridRL.pagerModule.pagerObj.pageSize;
    if (RL.name == "actionBegin" && RL.requestType == "filterbeforeopen") {
      this.RLFilterBo.type = RL.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveRelationshipListBO) {
    this.saveRLInfo = JSON.parse(JSON.stringify(saveBos));
  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveRLInfo = new saveRelationshipListBO();
    this.RLFilterBo = new GetTaxListBO();
    this.getRelationListFilter();
  }

  //.........................................getRelationListFilter.............................................
  getRelationListFilter() {
    this.DateService.execute(this.RLFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridRL.height = '500';
      }
      else {
        this.gridRL.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateRelationshipList.............................................
  SaveOrUpdateRelationshipList() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveRelationshipListBO = JSON.parse(JSON.stringify(this.saveRLInfo));
    savepayload.id = this.saveRLInfo.id;
    this.service.SaveRelationship(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('openRLModal').click();
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.saveRLInfo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Relationship saved successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
        else if (this.saveRLInfo.id != '00000000-0000-0000-0000-000000000000') {
          this.toasterservice.success('Relationship updated successfully!');
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
        document.getElementById('openRLModal').click();
        this.saveRLInfo = new saveRelationshipListBO();
        this.getRelationListFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showRelationColumns() {
    this.gridRL.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteRelationship...........................................................
  DeleteRelationship() {
    let params = new URLSearchParams();
    params.append("Id", this.saveRLInfo.id);
    this.service.DeleteRelationship(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Relationship deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeRLModal').click();
      this.getRelationListFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  clearRelations() {
    this.saveRLInfo = new saveRelationshipListBO();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
